const Menu = [
  {
    name: 'Bảng tin',
    active: 'the-news',
    link: '/dashboard',
    icon: 'vtd vtd-home',
    subMenu: []
  },
  {
    name: 'Thông báo',
    active: 'announcements',
    link: '/user/announcements',
    icon: 'vtd vtd-notification',
    subMenu: []
  },
  {
    name: 'Nhu cầu đã đăng',
    active: 'my-posted-demands',
    link: '/user/my-posted-demands',
    icon: 'vtd vtd-flag',
    subMenu: []
  },
  {
    name: 'Gửi nhu cầu',
    active: 'post-demand',
    link: '/user/post-demand',
    icon: 'vtd vtd-flag',
    subMenu: []
  },
  {
    name: 'Sản phẩm / Dịch vụ yêu thích',
    active: 'user-favorites',
    link: '/user/favorites',
    icon: 'vtd fa fa-heart-o',
    subMenu: []
  },
  {
    name: 'Yêu cầu đã gửi',
    active: 'my-requests',
    link: '/user/my-requests',
    icon: 'vtd vtd-menu',
    subMenu: []
  },
  {
    name: 'Giỏ hàng',
    active: 'MyShoppingCartPage',
    link: '/user/my-shopping-cart',
    icon: 'vtd vtd-gio-hang',
    subMenu: []
  },
  {
    name: 'Lịch sử giao dịch',
    active: 'user-order-history',
    link: '/user/order-history',
    icon: 'vtd vtd-lich-su-giao-dich',
    subMenu: []
  },
  {
    name: 'Doanh nghiệp của bạn',
    active: '',
    link: '/my-businesses',
    icon: 'vtd vtd-thong-tin-doanh-nghiep',
    subMenu: []
  },
  {
    name: 'Khiếu nại',
    active: 'my-post-complains',
    link: '/user/complains',
    icon: 'vtd vtd-khieu-nai',
    subMenu: []
  },
  {
    name: 'Thông tin cá nhân',
    active: 'profile',
    link: '/profile',
    icon: 'vtd vtd-credit-card',
    subMenu: []
  }
];

export {Menu};



// WEBPACK FOOTER //
// ./components/layouts/user/menu/menu.js